import React from "react";
import { ArrowRight } from "lucide-react";
import Reveal from "./Reveal";
import { TEAM_INTRO, TEAM_GROUP, CONTACT } from "../mock";
import "./Team.css";

const Team = () => (
  <section id="equipo" className="bg-2 py-24 lg:py-28" data-testid="team-section">
    <div className="max-w-6xl mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
      <Reveal className="lg:col-span-5">
        <p className="label" data-testid="team-label">Equipo</p>
        <h2 className="h-section mt-4" data-testid="team-title">La rama de energía y sostenibilidad de un grupo empresarial familiar.</h2>
      </Reveal>
      <Reveal delay={120} className="lg:col-span-7 lg:pt-10">
        <p className="team-text" data-testid="team-group">{TEAM_GROUP.text}</p>
        <p className="team-text mt-6" data-testid="team-intro">{TEAM_INTRO}</p>
        <div className="team-figure" data-testid="team-figure">
          <span className="team-figure-number">{TEAM_GROUP.years}</span>
          <span className="team-figure-caption">{TEAM_GROUP.caption}</span>
        </div>
        <a href={CONTACT.linkedin} target="_blank" rel="noopener noreferrer" className="link-arrow mt-10 text-sm inline-flex" data-testid="team-linkedin">
          Equipo en LinkedIn <ArrowRight className="w-4 h-4" />
        </a>
      </Reveal>
    </div>
  </section>
);

export default Team;
